import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Flex, ListBox, Item, View, ProgressCircle, Link } from '@adobe/react-spectrum';
import { CircleFill, ChevronDown, ChevronUp } from 'react-bootstrap-icons';
import { statusColor, truncateText } from '../../../../utils/helperUtil';
import { useViewInfo } from '../../../../hooks/UseViewInfo';
import { useDependency } from '../../../../contexts/DependencyProvider';
import { ListStatusRequest, ListStatusType } from '../../../../services/soap/project/requests/ListStatusRequest';
import { ListRegisterRequest } from '../../../../services/soap/features/requests/ListRegisterRequest';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../../state/store';
import { useSelector } from 'react-redux';
import styles from './event_work_type_filter_component.module.css';
import { GetSchedulerSettingsRequest, SettingsItemType } from '../../../../services/soap/scheduler/requests/GetSchedulerSettingsRequest';
import { GetTypeOfWorkForContextRequest } from '../../../../services/soap/scheduler/requests/GetTypeOfWorkForContextRequest';

interface EventWorktypeFilterComponentProps {
  createParams: (filterType: any, filterValue: any) => void;
  filterParams?: any;
}

const EventWorktypeFilterComponent: React.FC<EventWorktypeFilterComponentProps> = ({ createParams, filterParams }) => {
  const selectedApp = useSelector((state: RootState) => state.userWebLayout.selectedAppId);
  const { isMobile } = useViewInfo();
  const { t } = useTranslation('calendar');
  const _t = (key: string) => t(`calendar_filters.${key}`, { ns: 'calendar' });
  const { store, schedulerService } = useDependency();
  const [toggleListVisibility, setToggleListVisibility] = useState<any>({ stateList: true });
  const [stateSelectedKey, setStateSelectedKey] = useState<Set<string>>(new Set(['All states']));
  const EventWorktypeList = useRef<any>([]);
  const [showLoader, setShowLoader] = useState<boolean>(true);

  useEffect(() => {
    (async () => {
      await getEventWorktypeArray();
    })();
  }, [selectedApp]);

  const getEventWorktypeArray = useCallback(async () => {
    try {
      const statusArray: any = [];
      let scheduleResp = await schedulerService.getSchedulerSettings(new GetSchedulerSettingsRequest(store.Server, store.SessionId, '4', SettingsItemType.EVENT_ITEM_TYPE, 50, 0));
      if (scheduleResp.result === "OK") {
        scheduleResp?.ITEMS?.forEach((status: any) => {
          const { ident, title, color } = status.ITEM;
          let colorString = statusColor(color);
          statusArray.push({ ident, title, color: colorString });
        });
        EventWorktypeList.current = statusArray;
        let filterAvailableStates = filterParams?.FILTER.COL.filter((col: any) => col.name === 'customState');
        setStateSelectedKey(filterParams ? new Set(filterAvailableStates[0]?.value) : new Set(['All states']));
      }
    } finally {
      setShowLoader(false);
    }
  }, [selectedApp]);

  const handleSelectionChange = (value: any) => {
    const arrValue = Array.from(value);
    const allStatesCheck = arrValue.includes('All states') && arrValue.indexOf('All states') !== 0;

    if (allStatesCheck) {
      const allStatesSet = new Set(['All states']);
      setStateSelectedKey(allStatesSet);
      createParams('customState', allStatesSet);
    } else {
      const filteredValue = arrValue.filter(item => item !== 'All states');
      const updateValue = filteredValue.length > 0 ? new Set(filteredValue) : new Set(['All states']);
      setStateSelectedKey(new Set(Array.from(updateValue).map(String)));
      createParams('customState', updateValue);
    }
  };

  if (showLoader) {
    return (
      <Flex width="100%" height="100%" UNSAFE_style={{ backgroundColor: 'white' }} justifyContent={'center'} alignContent={'center'} alignItems={'center'}>
        <ProgressCircle aria-label="Loading…" isIndeterminate />
      </Flex>
    );
  } else {
    return (
      // <Flex direction={'column'} minWidth={'260px'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'}>
      //   <Flex direction={'column'} gap={'4px'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'} UNSAFE_className={styles.activity_status_container}>
      //     <Flex direction={'row'} height={'36px'} alignSelf={'stretch'} alignItems={'center'} justifyContent={'space-between'} UNSAFE_className={styles.activity_status_heading}>
      //       <Flex direction={'row'} flex={1} alignItems={'center'} justifyContent={'start'}>
      //         <View position={'relative'} UNSAFE_className={styles.activity_status_heading_text}>
      //           {_t('type_of_event')}
      //         </View>
      //       </Flex>

      //       {toggleListVisibility.stateList ? (
      //         <ChevronDown color="#B0BEC5" onClick={() => setToggleListVisibility((preValue: any) => ({ ...preValue, stateList: false }))} style={{ cursor: 'pointer' }} />
      //       ) : (
      //         <ChevronUp color="#B0BEC5" onClick={() => setToggleListVisibility((preValue: any) => ({ ...preValue, stateList: true }))} style={{ cursor: 'pointer' }} />
      //       )}
      //     </Flex>
      //     <Flex
      //       direction={'column'}
      //       alignSelf={'stretch'}
      //       alignItems={'start'}
      //       justifyContent={'start'}
      //       UNSAFE_className={isMobile ? styles.activity_status_component_mobile : styles.activity_status_component}
      //       UNSAFE_style={{ display: toggleListVisibility.stateList ? '' : 'none' }}
      //     >
      //       <ListBox
      //         id="listEventWorktype"
      //         width="100%"
      //         selectionMode="single"
      //         defaultSelectedKeys={stateSelectedKey}
      //         selectedKeys={stateSelectedKey}
      //         items={EventWorktypeList.current}
      //         onSelectionChange={(value: any) => {
      //           handleSelectionChange(value);
      //         }}
      //         UNSAFE_style={{ color: '#455a64 !important' }}
      //         aria-label="none"
      //       >
      //         {(item: any) => (
      //           <Item key={item.ident} textValue={truncateText(item.title, 18)}>
      //             <Flex direction={'row'} height={'30px'} UNSAFE_style={{ paddingBottom: '30px' }}>
      //               <View>
      //                 <CircleFill style={{ paddingRight: '10px', paddingTop: '6px' }} size={'18px'} color={item.color} />
      //               </View>
      //               <View UNSAFE_style={{ whiteSpace: 'nowrap', color: '#455a64 !important', lineHeight: '30px' }}>
      //                 <span title={item.title}>{truncateText(item.title, 18)}</span>
      //               </View>
      //             </Flex>
      //           </Item>
      //         )}
      //       </ListBox>
      //       <View position={'relative'} width={'100%'} height={'20px'} UNSAFE_className={styles.activity_status_clear_all_container}>
      //         <View position={'relative'} UNSAFE_className={styles.activity_status_clear_all_text}>
      //           <Link onPress={() => handleSelectionChange(new Set(['All states']))}>{t('clear_all', { ns: 'layout_components' })}</Link>
      //         </View>
      //       </View>
      //     </Flex>
      //   </Flex>
      // </Flex>
      <Flex direction={'column'} minWidth={'200px'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'} UNSAFE_style={{ overflowY: 'auto' }}>
        <Flex direction={'column'} gap={'4px'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'} UNSAFE_className={styles.type_of_work_container}>
          <Flex direction={'row'} height={'36px'} alignSelf={'stretch'} alignItems={'center'} justifyContent={'space-between'} UNSAFE_className={styles.type_of_work_heading}>
            <Flex direction={'row'} flex={1} alignItems={'center'} justifyContent={'start'}>
              <View position={'relative'} UNSAFE_className={styles.type_of_work_heading_text}>
                  {_t('type_of_event')}
              </View>
            </Flex>
            {toggleListVisibility.stateList ? (
              <ChevronDown color="#B0BEC5" onClick={() => setToggleListVisibility((preValue: any) => ({ ...preValue, stateList: false }))} style={{ cursor: 'pointer' }} />
            ) : (
              <ChevronUp onClick={() => setToggleListVisibility((preValue: any) => ({ ...preValue, stateList: true }))} style={{ cursor: 'pointer' }} />
            )}
          </Flex>
          <Flex
            direction={'column'}
            alignSelf={'stretch'}
            alignItems={'start'}
            justifyContent={'start'}
            UNSAFE_className={styles.type_of_work_component}
            UNSAFE_style={{ display: toggleListVisibility.stateList ? '' : 'none' }}
          >
            <ListBox
              id="listProjectStatus"
              width="100%"
              selectionMode="single"
              defaultSelectedKeys={stateSelectedKey}
              selectedKeys={stateSelectedKey}
              items={EventWorktypeList.current}
              onSelectionChange={(value: any) => {
                handleSelectionChange(value);
              }}
              UNSAFE_style={{ color: '#455a64 !important' }}
              aria-label="Project status filter"
            >
              {(item: any) => (
                <Item key={item.ident} textValue={item.title}>
                  <Flex direction={'row'} height={'30px'} UNSAFE_style={{ paddingBottom: '30px' }}>
                    <View UNSAFE_style={{ paddingTop: '4px', paddingLeft: '4px' }}>
                      <CircleFill style={{ paddingRight: '10px' }} size={'18px'} color={item.color} />
                    </View>
                    <View UNSAFE_style={{ whiteSpace: 'nowrap', color: '#455a64 !important', paddingTop: '5px' }}>
                      <span title={item.title}>{truncateText(item.title, 18)}</span>
                    </View>
                  </Flex>
                </Item>
              )}
            </ListBox>
            <View position={'relative'} width={'100%'} height={'20px'} UNSAFE_className={styles.type_of_work_clear_all_container}>
              <View position={'relative'} UNSAFE_className={styles.type_of_work_clear_all_text}>
                <Link
                  onPress={() => {
                    handleSelectionChange(new Set(['All states']));
                  }}
                >
                  {t('clear_all', { ns: 'layout_components' })}
                </Link>
              </View>
            </View>
          </Flex>
        </Flex>
      </Flex>
    );
    
  }
};

export default EventWorktypeFilterComponent;
